const RATERS = {
  ANCAP: 'ANCAP',
  UCSR: 'UCSR',
  NO_RATING: 'Not rated',
  NO_CURRENT_RATING: 'No current rating',
} as const;

export type Rater = (typeof RATERS)[keyof typeof RATERS];

export default RATERS;
